/* tslint:disable */
/* eslint-disable */
import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiConfiguration, ApiConfigurationParams } from './api-configuration';

import { CapacityService } from './services/capacity.service';
import { CompanyService } from './services/company.service';
import { DashboardService } from './services/dashboard.service';
import { DataMigrationsService } from './services/data-migrations.service';
import { DivisionsService } from './services/divisions.service';
import { EmployeeService } from './services/employee.service';
import { GroupService } from './services/group.service';
import { InventoryService } from './services/inventory.service';
import { MenuService } from './services/menu.service';
import { MenuV2Service } from './services/menu-v-2.service';
import { OrderBillService } from './services/order-bill.service';
import { OrderV2Service } from './services/order-v-2.service';
import { SupplierService } from './services/supplier.service';
import { SupplyService } from './services/supply.service';
import { TaxRateV2Service } from './services/tax-rate-v-2.service';
import { UnitOfMeasurementService } from './services/unit-of-measurement.service';
import { UserService } from './services/user.service';
import { VenueService } from './services/venue.service';

/**
 * Module that provides all services and configuration.
 */
@NgModule({
  imports: [],
  exports: [],
  declarations: [],
  providers: [
    CapacityService,
    CompanyService,
    DashboardService,
    DataMigrationsService,
    DivisionsService,
    EmployeeService,
    GroupService,
    InventoryService,
    MenuService,
    MenuV2Service,
    OrderBillService,
    OrderV2Service,
    SupplierService,
    SupplyService,
    TaxRateV2Service,
    UnitOfMeasurementService,
    UserService,
    VenueService,
    ApiConfiguration
  ],
})
export class ApiModule {
  static forRoot(params: ApiConfigurationParams): ModuleWithProviders<ApiModule> {
    return {
      ngModule: ApiModule,
      providers: [
        {
          provide: ApiConfiguration,
          useValue: params
        }
      ]
    }
  }

  constructor( 
    @Optional() @SkipSelf() parentModule: ApiModule,
    @Optional() http: HttpClient
  ) {
    if (parentModule) {
      throw new Error('ApiModule is already loaded. Import in your base AppModule only.');
    }
    if (!http) {
      throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
      'See also https://github.com/angular/angular/issues/20575');
    }
  }
}
